import { axios } from 'shared';
import { TenantLead } from './types';

export function fetchTenantLeads() {
  return axios.get<TenantLead[]>('/v1/tenant_leads');
}
